<template>
  <div>
    <v-autocomplete
      v-once
      :value="value"
      @input="input"
      :items="items"
      :label="label"
      :clearable="clearable"
      item-text="name"
      item-value="ref"
      :filled="!outlined"
      :outlined="outlined"
      chips
      hide-details
      hide-no-data
    >
      <template v-slot:selection="data">
        <v-chip pill v-if="!data.item.random">
          <v-avatar left>
            <img :src="data.item.picture" class="primary">
          </v-avatar>
          {{ data.item.name }}
        </v-chip>
        <v-chip pill v-else>
          Randomly generated
        </v-chip>
      </template>
      <template v-slot:item="data">
        <v-list-item-avatar v-if="!data.item.action">
          <img :src="data.item.picture" class="primary">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>

    <v-dialog
      v-model="randSeedDlg.show" 
      max-width="320"
      persistent
      @keydown.enter="onRandSeedDlgConfirm"
    >
      <v-card>
        <v-card-title class="headline">Random profile</v-card-title>
        <v-radio-group v-model="randSeedDlg.sex" row class="ma-0 pa-0 mt-2 ml-6">
          <v-radio label="Male" value="male" />
          <v-radio label="Female" value="female" />
        </v-radio-group>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onRandSeedDlgConfirm"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog
      v-model="inputSeedDlg.show"
      max-width="320"
      persistent
      @keydown.enter="onInputSeedDlgConfirm"
    >
      <v-card>
        <v-card-title class="headline">Input seed</v-card-title>
        <v-text-field
          v-model="inputSeedDlg.seed"
          class="ma-0 pa-0 mx-6"
          placeholder="Seed"
          hide-details />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onInputSeedDlgConfirm"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { randomSeed } from '../random-fb-profile'
const randSeedRef = 'RAND_SEED'
const inputSeedRef = 'INPUT_SEED'

export default {
  name: 'FbMemberAutocomplete',
  injectModels: ['Store'],
  props: {
    value: String,
    label: {
      type: String,
      default: 'Member'
    },
    clearable: Boolean,
    outlined: Boolean,
    noRandom: Boolean
  },
  data() {
    return {
      items: [],
      randSeedDlg: {
        show: false,
        sex: 'male'
      },
      inputSeedDlg: {
        show: false,
        seed: ''
      }
    }
  },
  created() {
    const items = this.Store.fbMembers()
    
    // TODO LOL BIG HAX ENERGY
    if (!this.noRandom) {
      items.unshift({
        ref: randSeedRef,
        action: true,
        random: true,
        name: 'Random profile'
      },
      {
        ref: inputSeedRef,
        action: true,
        random: true,
        name: 'Input seed'
      })

      if ((this.value || '').startsWith('@R'))
        items.push({
          ref: this.value,
          name: '',
          random: true,
          hide: true
        })
    }
    
    this.items = items
  },
  methods: {
    setValue(ref) {
      this.value = ref
      this.$emit('input', ref)
    },
    input(ref) {
      if (ref === randSeedRef) {
        this.randSeedDlg.show = true
      } else if (ref === inputSeedRef) {
        this.inputSeedDlg.show = true
      } else {
        this.setValue(ref)
      }
    },
    applySeed(seed) {
      this.setValue(`@R:${seed}`)
    },
    onInputSeedDlgConfirm() {
      this.applySeed(this.inputSeedDlg.seed || '1p')
      this.inputSeedDlg.show = false
    },
    onRandSeedDlgConfirm() {
      const male = this.randSeedDlg.sex === "male"
      const seed = randomSeed(male)
      this.applySeed(seed)
      this.randSeedDlg.show = false
    }
  }
}
</script>